import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE8Items = getItem('FE8', 'FE8', <FolderOutlined />, [
  getItem('Battle Preparations', 'FE8/BattlePreparations'),
  getItem('Battle Preperations', 'FE8/BattlePreperations'),
  getItem('Battle screen editor part 1', 'FE8/Battlescreeneditorpart1'),
  getItem('Battle screen editor part 2', 'FE8/Battlescreeneditorpart2'),
  getItem('Battle screen editor part 3', 'FE8/Battlescreeneditorpart3'),
  getItem('Battle screen editor part 4', 'FE8/Battlescreeneditorpart4'),
  getItem('Battle screen editor part 5', 'FE8/Battlescreeneditorpart5'),
  getItem('Chapter 1 Unit Editor', 'FE8/Chapter1UnitEditor'),
  getItem('Chapter 10A Unit Editor', 'FE8/Chapter10AUnitEditor'),
  getItem('Chapter 10B Armoury Editor', 'FE8/Chapter10BArmouryEditor'),
  getItem('Chapter 10B Cutscene Unit Editor', 'FE8/Chapter10BCutsceneUnitEditor'),
  getItem('Chapter 10B Shop Editor', 'FE8/Chapter10BShopEditor'),
  getItem('Chapter 10B Unit Editor', 'FE8/Chapter10BUnitEditor'),
  getItem('Chapter 11A Cutscene Unit Editor', 'FE8/Chapter11ACutsceneUnitEditor'),
  getItem('Chapter 11A Unit Editor', 'FE8/Chapter11AUnitEditor'),
  getItem('Chapter 11B Unit Editor', 'FE8/Chapter11BUnitEditor'),
  getItem('Chapter 12A Shop Editor', 'FE8/Chapter12AShopEditor'),
  getItem('Chapter 12A Unit Editor', 'FE8/Chapter12AUnitEditor'),
  getItem('Chapter 12B Shop Editor', 'FE8/Chapter12BShopEditor'),
  getItem('Chapter 12B Unit Editor', 'FE8/Chapter12BUnitEditor'),
  getItem('Chapter 13A Cutscene Unit Editor', 'FE8/Chapter13ACutsceneUnitEditor'),
  getItem('Chapter 13A Cutscene2 Unit Editor', 'FE8/Chapter13ACutscene2UnitEditor'),
  getItem('Chapter 13A Unit Editor', 'FE8/Chapter13AUnitEditor'),
  getItem('Chapter 13B Unit Editor', 'FE8/Chapter13BUnitEditor'),
  getItem('Chapter 14A Cutscene Unit Editor', 'FE8/Chapter14ACutsceneUnitEditor'),
  getItem('Chapter 14A Cutscene2 Unit Editor', 'FE8/Chapter14ACutscene2UnitEditor'),
  getItem('Chapter 14A Cutscene3 Unit Editor', 'FE8/Chapter14ACutscene3UnitEditor'),
  getItem('Chapter 14A Secret Editor', 'FE8/Chapter14ASecretEditor'),
  getItem('Chapter 14A Unit Editor', 'FE8/Chapter14AUnitEditor'),
  getItem('Chapter 14B Cutscene Unit Editor', 'FE8/Chapter14BCutsceneUnitEditor'),
  getItem('Chapter 14B Cutscene2 Unit Editor', 'FE8/Chapter14BCutscene2UnitEditor'),
  getItem('Chapter 14B Cutscene3 Unit Editor', 'FE8/Chapter14BCutscene3UnitEditor'),
  getItem('Chapter 14B Secret Editor', 'FE8/Chapter14BSecretEditor'),
  getItem('Chapter 14B Unit Editor', 'FE8/Chapter14BUnitEditor'),
  getItem('Chapter 15A Shop Editor', 'FE8/Chapter15AShopEditor'),
  getItem('Chapter 15A Unit Editor', 'FE8/Chapter15AUnitEditor'),
  getItem('Chapter 15B Shop Editor', 'FE8/Chapter15BShopEditor'),
  getItem('Chapter 15B Unit Editor', 'FE8/Chapter15BUnitEditor'),
  getItem('Chapter 16A Cutscene Unit Editor', 'FE8/Chapter16ACutsceneUnitEditor'),
  getItem('Chapter 16A Cutscene2 Unit Editor', 'FE8/Chapter16ACutscene2UnitEditor'),
  getItem('Chapter 16A Cutscene3 Unit Editor', 'FE8/Chapter16ACutscene3UnitEditor'),
  getItem('Chapter 16A Cutscene4 Unit Editor', 'FE8/Chapter16ACutscene4UnitEditor'),
  getItem('Chapter 16A Cutscene5 Unit Editor', 'FE8/Chapter16ACutscene5UnitEditor'),
  getItem('Chapter 16A Unit Editor', 'FE8/Chapter16AUnitEditor'),
  getItem('Chapter 16B Unit Editor', 'FE8/Chapter16BUnitEditor'),
  getItem('Chapter 17A Armoury Editor', 'FE8/Chapter17AArmouryEditor'),
  getItem('Chapter 17A Shop Editor', 'FE8/Chapter17AShopEditor'),
  getItem('Chapter 17A Unit Editor', 'FE8/Chapter17AUnitEditor'),
  getItem('Chapter 17B Armoury Editor', 'FE8/Chapter17BArmouryEditor'),
  getItem('Chapter 17B Shop Editor', 'FE8/Chapter17BShopEditor'),
  getItem('Chapter 17B Unit Editor', 'FE8/Chapter17BUnitEditor'),
  getItem('Chapter 18A Unit Editor', 'FE8/Chapter18AUnitEditor'),
  getItem('Chapter 18B Unit Editor', 'FE8/Chapter18BUnitEditor'),
  getItem('Chapter 19A Cutscene Unit Editor', 'FE8/Chapter19ACutsceneUnitEditor'),
  getItem('Chapter 19A Secret Editor', 'FE8/Chapter19ASecretEditor'),
  getItem('Chapter 19A Unit Editor', 'FE8/Chapter19AUnitEditor'),
  getItem('Chapter 19B Secret Editor', 'FE8/Chapter19BSecretEditor'),
  getItem('Chapter 19B Unit Editor', 'FE8/Chapter19BUnitEditor'),
  getItem('Chapter 2 Armoury Editor', 'FE8/Chapter2ArmouryEditor'),
  getItem('Chapter 2 Unit Editor', 'FE8/Chapter2UnitEditor'),
  getItem('Chapter 20A Cutscene Unit Editor', 'FE8/Chapter20ACutsceneUnitEditor'),
  getItem('Chapter 20A Unit Editor', 'FE8/Chapter20AUnitEditor'),
  getItem('Chapter 20B Unit Editor', 'FE8/Chapter20BUnitEditor'),
  getItem('Chapter 3 Cutscene Unit Editor', 'FE8/Chapter3CutsceneUnitEditor'),
  getItem('Chapter 3 Unit Editor', 'FE8/Chapter3UnitEditor'),
  getItem('Chapter 4 Unit Editor', 'FE8/Chapter4UnitEditor'),
  getItem('Chapter 5 Armoury Editor', 'FE8/Chapter5ArmouryEditor'),
  getItem('Chapter 5 Shop Editor', 'FE8/Chapter5ShopEditor'),
  getItem('Chapter 5 Unit Editor', 'FE8/Chapter5UnitEditor'),
  getItem('Chapter 5x Cutscene Unit Editor', 'FE8/Chapter5xCutsceneUnitEditor'),
  getItem('Chapter 5x Cutscene2 Unit Editor', 'FE8/Chapter5xCutscene2UnitEditor'),
  getItem('Chapter 5x Unit Editor', 'FE8/Chapter5xUnitEditor'),
  getItem('Chapter 6 Unit Editor', 'FE8/Chapter6UnitEditor'),
  getItem('Chapter 7 Unit Editor', 'FE8/Chapter7UnitEditor'),
  getItem('Chapter 8 Cutscene 2 Unit Editor', 'FE8/Chapter8Cutscene2UnitEditor'),
  getItem('Chapter 8 Cutscene Unit Editor', 'FE8/Chapter8CutsceneUnitEditor'),
  getItem('Chapter 8 Unit Editor', 'FE8/Chapter8UnitEditor'),
  getItem('Chapter 9A Armoury Editor', 'FE8/Chapter9AArmouryEditor'),
  getItem('Chapter 9A Cutscene Unit Editor', 'FE8/Chapter9ACutsceneUnitEditor'),
  getItem('Chapter 9A Shop Editor', 'FE8/Chapter9AShopEditor'),
  getItem('Chapter 9A Unit Editor', 'FE8/Chapter9AUnitEditor'),
  getItem('Chapter 9B Cutscene Unit Editor', 'FE8/Chapter9BCutsceneUnitEditor'),
  getItem('Chapter 9B Cutscene2 Unit Editor', 'FE8/Chapter9BCutscene2UnitEditor'),
  getItem('Chapter 9B Unit Editor', 'FE8/Chapter9BUnitEditor'),
  getItem('Chapter FinalA Unit Editor', 'FE8/ChapterFinalAUnitEditor'),
  getItem('Chapter FinalB & Tower of Valni 1 Unit Editor', 'FE8/ChapterFinalBTowerofValni1UnitEditor'),
  getItem('Chapter FinalBoss Unit Editor', 'FE8/ChapterFinalBossUnitEditor'),
  getItem('FE 8 Crit bonus editor', 'FE8/Critbonuseditor'),
  getItem('FE 8 Event table editor', 'FE8/Eventtableeditor'),
  getItem('FE 8 Map sprite pointer table editor', 'FE8/Mapspritepointertableeditor'),
  getItem('FE8 Battle Palette Reference', 'FE8/BattlePaletteReference'),
  getItem('FE8 Boss Quote Editor', 'FE8/BossQuoteEditor'),
  getItem('FE8 Boss/Special Death Quote Editor', 'FE8/SpecialDeathQuoteEditor'),
  getItem('FE8 Ch 1 Event Tile Editor', 'FE8/Ch1EventTileEditor'),
  getItem('FE8 Ch 1 Reinforcement Editor', 'FE8/Ch1ReinforcementEditor'),
  getItem('FE8 Ch 10 Ephraim recruitment editor', 'FE8/Ch10Ephraimrecruitmenteditor'),
  getItem('FE8 Ch 10 irika recruitment editor', 'FE8/Ch10irikarecruitmenteditor'),
  getItem('FE8 Ch 10A Event Tile Editor', 'FE8/Ch10AEventTileEditor'),
  getItem('FE8 Ch 10A Reinforcement Editor', 'FE8/Ch10AReinforcementEditor'),
  getItem('FE8 Ch 10B Event Tile Editor', 'FE8/Ch10BEventTileEditor'),
  getItem('FE8 Ch 10B Reinforcement Editor', 'FE8/Ch10BReinforcementEditor'),
  getItem('FE8 Ch 11 Eirika recruitment editor', 'FE8/Ch11Eirikarecruitmenteditor'),
  getItem('FE8 Ch 11 Ephraim recruitment editor', 'FE8/Ch11Ephraimrecruitmenteditor'),
  getItem('FE8 Ch 11A Chest Editor', 'FE8/Ch11AChestEditor'),
  getItem('FE8 Ch 11A Reinforcement Editor', 'FE8/Ch11AReinforcementEditor'),
  getItem('FE8 Ch 11B Event Tile Editor', 'FE8/Ch11BEventTileEditor'),
  getItem('FE8 Ch 11B Reinforcement Editor', 'FE8/Ch11BReinforcementEditor'),
  getItem('FE8 Ch 12 Ephraim recruitment editor', 'FE8/Ch12Ephraimrecruitmenteditor'),
  getItem('FE8 Ch 12A Event Tile Editor', 'FE8/Ch12AEventTileEditor'),
  getItem('FE8 Ch 12A Reinforcement Editor', 'FE8/Ch12AReinforcementEditor'),
  getItem('FE8 Ch 12B Event Tile Editor', 'FE8/Ch12BEventTileEditor'),
  getItem('FE8 Ch 12B Reinforcement Editor', 'FE8/Ch12BReinforcementEditor'),
  getItem('FE8 Ch 13 Eirika recruitment editor', 'FE8/Ch13Eirikarecruitmenteditor'),
  getItem('FE8 Ch 13A Event Tile Editor', 'FE8/Ch13AEventTileEditor'),
  getItem('FE8 Ch 13A Reinforcement Editor', 'FE8/Ch13AReinforcementEditor'),
  getItem('FE8 Ch 13B Event Tile Editor', 'FE8/Ch13BEventTileEditor'),
  getItem('FE8 Ch 13B Reinforcement Editor', 'FE8/Ch13BReinforcementEditor'),
  getItem('FE8 Ch 14 Eirika recruitment editor', 'FE8/Ch14Eirikarecruitmenteditor'),
  getItem('FE8 Ch 14A Chest Editor', 'FE8/Ch14AChestEditor'),
  getItem('FE8 Ch 14A Reinforcement Editor', 'FE8/Ch14AReinforcementEditor'),
  getItem('FE8 Ch 14B Chest Editor', 'FE8/Ch14BChestEditor'),
  getItem('FE8 Ch 14B Reinforcement Editor', 'FE8/Ch14BReinforcementEditor'),
  getItem('FE8 Ch 15A Event Tile Editor', 'FE8/Ch15AEventTileEditor'),
  getItem('FE8 Ch 15A Reinforcement Editor', 'FE8/Ch15AReinforcementEditor'),
  getItem('FE8 Ch 15B Event Tile Editor', 'FE8/Ch15BEventTileEditor'),
  getItem('FE8 Ch 15B Reinforcement Editor', 'FE8/Ch15BReinforcementEditor'),
  getItem('FE8 Ch 16A Chest Editor', 'FE8/Ch16AChestEditor'),
  getItem('FE8 Ch 16A Reinforcement Editor', 'FE8/Ch16AReinforcementEditor'),
  getItem('FE8 Ch 16B Chest Editor', 'FE8/Ch16BChestEditor'),
  getItem('FE8 Ch 16B Reinforcement Editor', 'FE8/Ch16BReinforcementEditor'),
  getItem('FE8 Ch 17 Eirika recruitment editor', 'FE8/Ch17Eirikarecruitmenteditor'),
  getItem('FE8 Ch 17A Event Tile Editor', 'FE8/Ch17AEventTileEditor'),
  getItem('FE8 Ch 17A Reinforcement Editor', 'FE8/Ch17AReinforcementEditor'),
  getItem('FE8 Ch 17B Event Tile Editor', 'FE8/Ch17BEventTileEditor'),
  getItem('FE8 Ch 17B Reinforcement Editor', 'FE8/Ch17BReinforcementEditor'),
  getItem('FE8 Ch 18A Event Tile Editor', 'FE8/Ch18AEventTileEditor'),
  getItem('FE8 Ch 18A Reinforcement Editor', 'FE8/Ch18AReinforcementEditor'),
  getItem('FE8 Ch 18B Event Tile Editor', 'FE8/Ch18BEventTileEditor'),
  getItem('FE8 Ch 18B Reinforcement Editor', 'FE8/Ch18BReinforcementEditor'),
  getItem('FE8 Ch 19A Chest Editor', 'FE8/Ch19AChestEditor'),
  getItem('FE8 Ch 19A Reinforcement Editor', 'FE8/Ch19AReinforcementEditor'),
  getItem('FE8 Ch 19B Chest Editor', 'FE8/Ch19BChestEditor'),
  getItem('FE8 Ch 19B Reinforcement Editor', 'FE8/Ch19BReinforcementEditor'),
  getItem('FE8 Ch 2 Event Tile Editor', 'FE8/Ch2EventTileEditor'),
  getItem('FE8 Ch 2 recruitment editor', 'FE8/Ch2recruitmenteditor'),
  getItem('FE8 Ch 2 Reinforcement Editor', 'FE8/Ch2ReinforcementEditor'),
  getItem('FE8 Ch 20A Event Tile Editor', 'FE8/Ch20AEventTileEditor'),
  getItem('FE8 Ch 20A Reinforcement Editor', 'FE8/Ch20AReinforcementEditor'),
  getItem('FE8 Ch 20B Event Tile Editor', 'FE8/Ch20BEventTileEditor'),
  getItem('FE8 Ch 20B Reinforcement Editor', 'FE8/Ch20BReinforcementEditor'),
  getItem('FE8 Ch 3 Chest Editor', 'FE8/Ch3ChestEditor'),
  getItem('FE8 Ch 3 recruitment editor', 'FE8/Ch3recruitmenteditor'),
  getItem('FE8 Ch 3 Reinforcement Editor', 'FE8/Ch3ReinforcementEditor'),
  getItem('FE8 Ch 4 Event Tile Editor', 'FE8/Ch4EventTileEditor'),
  getItem('FE8 Ch 4 Reinforcement Editor', 'FE8/Ch4ReinforcementEditor'),
  getItem('FE8 Ch 5 Chest Editor', 'FE8/Ch5ChestEditor'),
  getItem('FE8 Ch 5 recruitment editor', 'FE8/Ch5recruitmenteditor'),
  getItem('FE8 Ch 5 Reinforcement Editor', 'FE8/Ch5ReinforcementEditor'),
  getItem('FE8 Ch 5x Chest Editor', 'FE8/Ch5xChestEditor'),
  getItem('FE8 Ch 6 Event Tile Editor', 'FE8/Ch6EventTileEditor'),
  getItem('FE8 Ch 6 Reinforcement Editor', 'FE8/Ch6ReinforcementEditor'),
  getItem('FE8 Ch 7 Event Tile Editor', 'FE8/Ch7EventTileEditor'),
  getItem('FE8 Ch 7 Reinforcement Editor', 'FE8/Ch7ReinforcementEditor'),
  getItem('FE8 Ch 8 Chest Editor', 'FE8/Ch8ChestEditor'),
  getItem('FE8 Ch 8 Reinforcement Editor', 'FE8/Ch8ReinforcementEditor'),
  getItem('FE8 Ch 9 Eirika recruitment editor', 'FE8/Ch9Eirikarecruitmenteditor'),
  getItem('FE8 Ch 9 Ephraim recruitment editor', 'FE8/Ch9Ephraimrecruitmenteditor'),
  getItem('FE8 Ch 9A Event Tile Editor', 'FE8/Ch9AEventTileEditor'),
  getItem('FE8 Ch 9A Reinforcement Editor', 'FE8/Ch9AReinforcementEditor'),
  getItem('FE8 Ch 9B Chest Editor', 'FE8/Ch9BChestEditor'),
  getItem('FE8 Ch 9B Reinforcement Editor', 'FE8/Ch9BReinforcementEditor'),
  getItem('FE8 Ch FinalA Chest Editor', 'FE8/ChFinalAChestEditor'),
  getItem('FE8 Ch FinalA Reinforcement Editor', 'FE8/ChFinalAReinforcementEditor'),
  getItem('FE8 Ch FinalB Chest Editor', 'FE8/ChFinalBChestEditor'),
  getItem('FE8 Ch FinalB Reinforcement Editor', 'FE8/ChFinalBReinforcementEditor'),
  getItem('FE8 Ch FinalBossA Event Tile Editor', 'FE8/ChFinalBossAEventTileEditor'),
  getItem('FE8 Ch FinalBossB Event Tile Editor', 'FE8/ChFinalBossBEventTileEditor'),
  getItem('FE8 Chapter Data Editor', 'FE8/ChapterDataEditor'),
  getItem('FE8 Character Editor', 'FE8/CharacterEditor'),
  getItem('FE8 Class Changing Table', 'FE8/ClassChangingTable'),
  getItem('FE8 Class Editor', 'FE8/ClassEditor'),
  getItem('FE8 Custom Battle Animation Editor', 'FE8/CustomBattleAnimationEditor'),
  getItem('FE8 Custom Item Animation List', 'FE8/CustomItemAnimationList'),
  getItem('FE8 Custom Promotion Pointer Editor', 'FE8/CustomPromotionPointerEditor'),
  getItem('FE8 Custom Support Pointer Editor', 'FE8/CustomSupportPointerEditor'),
  getItem('FE8 Item Editor', 'FE8/ItemEditor'),
  getItem('FE8 Item Effect Pointer Editor', 'FE8/ItemEffectPointerEditor'),
  getItem('FE8 Item Randomizing Table Editor', 'FE8/ItemRandomizingTableEditor'),
  getItem('FE8 Item Target Pointer Editor', 'FE8/ItemTargetPointerEditor'),
  getItem('FE8 Item Usability Pointer Editor', 'FE8/ItemUsabilityPointerEditor'),
  getItem('FE8 Ocean Seal Promotion Editor', 'FE8/OceanSealPromotionEditor'),
  getItem('FE8 Palette Association Editor', 'FE8/PaletteAssociationEditor'),
  getItem('FE8 Portrait Editor', 'FE8/PortraitEditor'),
  getItem('FE8 Prologue Event Tile Editor', 'FE8/PrologueEventTileEditor'),
  getItem('FE8 Promotion Branch Editor', 'FE8/PromotionBranchEditor'),
  getItem('FE8 Promotion Item Editor', 'FE8/PromotionItemEditor'),
  getItem('FE8 Promotion level editor', 'FE8/Promotionleveleditor'),
  getItem('FE8 Random Item Groups Table', 'FE8/RandomItemGroupsTable'),
  getItem('FE8 Random Item Probability Group Table', 'FE8/RandomItemProbabilityGroupTable'),
  getItem('FE8 Sound Room Editor', 'FE8/SoundRoomEditor'),
  getItem('FE8 Spell Association Editor', 'FE8/SpellAssociationEditor'),
  getItem('FE8 Standing map sprite editor', 'FE8/Standingmapspriteeditor'),
  getItem('FE8 Stat Bonuses Editor', 'FE8/StatBonusesEditor'),
  getItem('FE8 Summon editor', 'FE8/Summoneditor'),
  getItem('FE8 Support Pointer Editor', 'FE8/SupportPointerEditor'),
  getItem('FE8 Terrain Stat Editor', 'FE8/TerrainStatEditor'),
  getItem('FE8 Unknown0 Event Tile Editor', 'FE8/Unknown0EventTileEditor'),
  getItem('FE8 Unknown1 Event Tile Editor', 'FE8/Unknown1EventTileEditor'),
  getItem('FE8 Unknown1 Reinforcement Editor', 'FE8/Unknown1ReinforcementEditor'),
  getItem('FE8 Unknown10 Chest Editor', 'FE8/Unknown10ChestEditor'),
  getItem('FE8 Unknown10 Reinforcement Editor', 'FE8/Unknown10ReinforcementEditor'),
  getItem('FE8 Unknown11 Event Tile Editor', 'FE8/Unknown11EventTileEditor'),
  getItem('FE8 Unknown11 Reinforcement Editor', 'FE8/Unknown11ReinforcementEditor'),
  getItem('FE8 Unknown12 Event Tile Editor', 'FE8/Unknown12EventTileEditor'),
  getItem('FE8 Unknown13 Event Tile Editor', 'FE8/Unknown13EventTileEditor'),
  getItem('FE8 Unknown13 Reinforcement Editor', 'FE8/Unknown13ReinforcementEditor'),
  getItem('FE8 Unknown14 Event Tile Editor', 'FE8/Unknown14EventTileEditor'),
  getItem('FE8 Unknown14 Reinforcement Editor', 'FE8/Unknown14ReinforcementEditor'),
  getItem('FE8 Unknown15 Event Tile Editor', 'FE8/Unknown15EventTileEditor'),
  getItem('FE8 Unknown15 Reinforcement Editor', 'FE8/Unknown15ReinforcementEditor'),
  getItem('FE8 Unknown16 Event Tile Editor', 'FE8/Unknown16EventTileEditor'),
  getItem('FE8 Unknown16 Reinforcement Editor', 'FE8/Unknown16ReinforcementEditor'),
  getItem('FE8 Unknown17 Event Tile Editor', 'FE8/Unknown17EventTileEditor'),
  getItem('FE8 Unknown18 Event Tile Editor', 'FE8/Unknown18EventTileEditor'),
  getItem('FE8 Unknown19 Event Tile Editor', 'FE8/Unknown19EventTileEditor'),
  getItem('FE8 Unknown2 Chest Editor', 'FE8/Unknown2ChestEditor'),
  getItem('FE8 Unknown20 Event Tile Editor', 'FE8/Unknown20EventTileEditor'),
  getItem('FE8 Unknown20 Reinforcement Editor', 'FE8/Unknown20ReinforcementEditor'),
  getItem('FE8 Unknown21 Event Tile Editor', 'FE8/Unknown21EventTileEditor'),
  getItem('FE8 Unknown3 Event Tile Editor', 'FE8/Unknown3EventTileEditor'),
  getItem('FE8 Unknown4 Event Tile Editor', 'FE8/Unknown4EventTileEditor'),
  getItem('FE8 Unknown4 Reinforcement Editor', 'FE8/Unknown4ReinforcementEditor'),
  getItem('FE8 Unknown5 Chest Editor', 'FE8/Unknown5ChestEditor'),
  getItem('FE8 Unknown6 Event Tile Editor', 'FE8/Unknown6EventTileEditor'),
  getItem('FE8 Unknown6 Reinforcement Editor', 'FE8/Unknown6ReinforcementEditor'),
  getItem('FE8 Unknown7 Chest Editor', 'FE8/Unknown7ChestEditor'),
  getItem('FE8 Unknown8 Event Tile Editor', 'FE8/Unknown8EventTileEditor'),
  getItem('FE8 Unknown8 Reinforcement Editor', 'FE8/Unknown8ReinforcementEditor'),
  getItem('FE8 Unknown9 Event Tile Editor', 'FE8/Unknown9EventTileEditor'),
  getItem('Fire Emblem 8 (Paired) Endings Editor ', 'FE8/FireEmblem8PairedEndingsEditor'),
  getItem('Fire Emblem 8 Support compatibility Editor ', 'FE8/FireEmblem8SupportcompatibilityEditor'),
  getItem('Fire Emblem 8 Support Convo Availability Editor ', 'FE8/FireEmblem8SupportConvoAvailabilityEditor'),
  getItem('Lagdou Ruins 2 & Melkaen Coast Unit Editor', 'FE8/LagdouRuins2MelkaenCoastUnitEditor'),
  getItem('Level Cap Editor', 'FE8/LevelCapEditor'),
  getItem('Map - Bethroen Armoury Editor', 'FE8/MapBethroenArmouryEditor'),
  getItem('Map - Bethroen Shop Editor', 'FE8/MapBethroenShopEditor'),
  getItem('Map - Caer Pelyn Shop Editor', 'FE8/MapCaerPelynShopEditor'),
  getItem('Map - Grado Keep Secret Editor', 'FE8/MapGradoKeepSecretEditor'),
  getItem('Map - Ide Armoury Editor', 'FE8/MapIdeArmouryEditor'),
  getItem('Map - Jehanna Hall Secret Editor', 'FE8/MapJehannaHallSecretEditor'),
  getItem('Map - Jehanna Hall Shop Editor', 'FE8/MapJehannaHallShopEditor'),
  getItem('Map - Narube River Armoury Editor', 'FE8/MapNarubeRiverArmouryEditor'),
  getItem('Map - Narube River Shop Editor', 'FE8/MapNarubeRiverShopEditor'),
  getItem('Map - Port Kiris Armoury Editor', 'FE8/MapPortKirisArmouryEditor'),
  getItem('Map - Port Kiris Shop Editor', 'FE8/MapPortKirisShopEditor'),
  getItem('Map - Rausten Court Armoury Editor', 'FE8/MapRaustenCourtArmouryEditor'),
  getItem('Map - Rausten Court Secret Editor', 'FE8/MapRaustenCourtSecretEditor'),
  getItem('Map - Rausten Court Shop Editor', 'FE8/MapRaustenCourtShopEditor'),
  getItem('Map - Serafew Armoury Editor', 'FE8/MapSerafewArmouryEditor'),
  getItem('Map - Serafew Shop Editor', 'FE8/MapSerafewShopEditor'),
  getItem('Map - Taizel Shop Editor', 'FE8/MapTaizelShopEditor'),
  getItem('Prologue Cutscene Unit Editor', 'FE8/PrologueCutsceneUnitEditor'),
  getItem('Prologue Cutscene2 Unit Editor', 'FE8/PrologueCutscene2UnitEditor'),
  getItem('Prologue Unit Editor', 'FE8/PrologueUnitEditor'),
  getItem('S-Rank Bonus Editor', 'FE8/SRankBonusEditor'),
  getItem('Summon character editor', 'FE8/Summoncharactereditor'),
  getItem('Support bonus editor', 'FE8/Supportbonuseditor'),
  getItem('Tower of Valni 2 Unit Editor', 'FE8/TowerofValni2UnitEditor'),
  getItem('Tower of Valni 3 Unit Editor', 'FE8/TowerofValni3UnitEditor'),
  getItem('Tower of Valni 4 & Lagdou Ruins 1 Unit Editor', 'FE8/TowerofValni4LagdouRuins1UnitEditor'),
  getItem('Unit Menu table', 'FE8/UnitMenutable'),
  getItem('Unknown5 Unit Editor', 'FE8/Unknown5UnitEditor'),
  getItem('Unknown6 Unit Editor', 'FE8/Unknown6UnitEditor'),
]);

export default FE8Items;
